module.exports = __webpack_public_path__ + "img/logo.2ad262a6.png";